import React from 'react';
import { motion } from 'framer-motion';
import { Button } from '../../components/ui/button';
import { Card, CardContent } from '../../components/ui/card';
import { Input } from '../../components/ui/input';
import { Loader2, ArrowLeft, Mail } from 'lucide-react';

export default function FinishStep({ email, setEmail, onFinish, finishing, onBack }) {
  return (
    <motion.div
      key="finish"
      initial={{ opacity: 0, x: 20 }}
      animate={{ opacity: 1, x: 0 }}
      exit={{ opacity: 0, x: -20 }}
      className="space-y-4"
    >
      <Card className="card-shadow">
        <CardContent className="pt-8 pb-8 space-y-6">
          {/* Heading */}
          <div className="text-center">
            <h2 className="text-xl font-semibold mb-1">Fast fertig!</h2>
            <p className="text-sm text-muted-foreground">
              Hinterlassen Sie optional Ihre E-Mail-Adresse — dann können Sie Ihre Bewertung später bearbeiten oder verifizieren.
            </p>
          </div>

          {/* Email field */}
          <div>
            <label className="text-sm font-medium mb-1.5 block">
              E-Mail-Adresse <span className="text-muted-foreground font-normal">(optional)</span>
            </label>
            <div className="relative">
              <Mail className="absolute left-3 top-1/2 -translate-y-1/2 w-4 h-4 text-muted-foreground" />
              <Input
                type="email"
                value={email}
                onChange={(e) => setEmail(e.target.value)}
                placeholder="ihre@email.de"
                className="pl-10"
                data-testid="finish-email-input"
              />
            </div>
            <p className="text-xs text-muted-foreground mt-1.5">
              Sie erhalten einen Link, mit dem Sie Ihre Bewertung bestätigen, bearbeiten oder löschen können. Keine Werbung.
              Mehr in der <a href="/datenschutz" target="_blank" rel="noopener noreferrer" className="underline hover:text-foreground">Datenschutzerklärung</a>.
            </p>
          </div>

          {/* Actions */}
          <div className="space-y-2 pt-1">
            <Button
              onClick={onFinish}
              disabled={finishing}
              className="w-full"
              data-testid="finish-submit-button"
            >
              {finishing && <Loader2 className="w-4 h-4 animate-spin mr-2" />}
              {email ? 'Bewertung abschließen & E-Mail senden' : 'Bewertung abschließen'}
            </Button>
            {onBack && (
              <Button
                variant="ghost"
                size="sm"
                onClick={onBack}
                className="w-full text-muted-foreground"
              >
                <ArrowLeft className="w-4 h-4 mr-2" />
                Zurück
              </Button>
            )}
          </div>
        </CardContent>
      </Card>
    </motion.div>
  );
}
